import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

import {Container} from '@/modules/foundation/components/container';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import {DesktopNav} from './DesktopNav';
import type {DropdownType} from './Dropdown';
import {MobileNav} from './MobileNav';
import type {NavLinkType} from './NavLink';

export type NavigationType = KeyedArray<NavLinkType | DropdownType>;

type NavbarProps = {
	navigation: NavigationType;
};

const FRONT_PAGE = 'Forside';

export const Navbar = ({navigation}: NavbarProps) => {
	return (
		<Container
			as="header"
			className={clsx(
				'relative',
				'z-50',
				'bg-white',
				'md:shadow-[0_4px_4px_0px_rgba(0,74,127,0.25)]',
			)}
		>
			<div
				className={clsx(
					'flex',
					'h-20',
					'md:h-24',
					'items-center',
					'justify-between',
					'gap-4',
				)}
			>
				<Link href="/">
					<span className={clsx('sr-only')}>{FRONT_PAGE}</span>
					<Image
						src="/logo.svg"
						alt=""
						width={270}
						height={60}
						className={clsx('hidden', 'md:block')}
					/>
					<Image
						src="/logo.svg"
						alt=""
						width={250}
						height={55}
						className={clsx('md:hidden')}
					/>
				</Link>
				{navigation ? (
					<>
						<DesktopNav navigation={navigation} />
						<MobileNav navigation={navigation} />
					</>
				) : null}
			</div>
		</Container>
	);
};
